// Cache condivisa dell'elenco utenti (endpoint async-users) usata dai filtri
// avanzati per popolare i selettori di condivisione dei filtri salvati.
//
// Memoizza la Promise così la chiamata parte una sola volta e non viene rifatta
// a ogni apertura del drawer / cambio pagina CRUD (task #7276). La cache NON
// deve sopravvivere al cambio di principal: il logout è "soft" (router.push,
// senza reload), quindi va invalidata esplicitamente al logout — vedi
// invalidateUsersOptionsCache(), richiamata dallo store auth.
let cache = null

export function fetchUsersOptions(axios) {
	if (!cache) {
		cache = axios.get('async-users').then(
			response => response.data || [],
			() => {
				// Non memorizzare i fallimenti: un tentativo successivo ritenta.
				cache = null
				return []
			}
		)
	}
	return cache
}

export function invalidateUsersOptionsCache() {
	cache = null
}
